export const ExpenseStatus = {
	REQUESTED: 'REQUESTED',
	APPROVED: 'APPROVED',
	PAID: 'PAID',
	REFUSED: 'REFUSED'
}
